export function logging (eventName, value) {
  if (value instanceof Object) {
    console.log(`[${eventName}]`);
    console.log(value);
  } else {
    console.log(`[${eventName}] ${value}`);
  }
}
